export default __webpack_public_path__ + "static/media/Months_15.ddf08e62.png";